<header class="content-page__header header-article" [class.has--image]="image?.url">
  <div class="header-article__content bg-background topbar-padding-top">
    <main class="header-article__content__inner container container-size-sm section-inset-y">
      <ng-content select="breadcrumbs"></ng-content>

      @if (subtitle) {
        <strong class="h1 text-light text-max-width-xs">
          {{ subtitle }}
        </strong>
      }

      @if (title) {
        <h1 [class.mb-0]="!intro">{{ title }}</h1>
      }
      @if (intro) {
        <p class="mb-0">{{ intro }}</p>
      }

      <!-- Button -->
      @if (button?.url) {
        <a class="button button--secondary mt-4" [href]="button?.url">
          <span>{{ button?.text || 'Shop nu' }}</span>
        </a>
      }
      @if (button?.routerLink?.length && !button?.url) {
        <a class="button button--secondary mt-4" [routerLink]="button?.routerLink">
          <span>{{ button?.text || 'Shop nu' }}</span>
        </a>
      }
      <!-- Button end -->
    </main>
  </div>
  @if (image?.url) {
    <div class="header-article__figure">
      <figure class="container container-size-sm">
        <img
          class="header-article__figure__image"
          [src]="(image?.url || '' | resize: 1200:undefined:image?.anchor:'crop':'webp') + '&maxheight=800'"
          [alt]="image?.alt || image?.caption || title"
          />
      </figure>
    </div>
  }
</header>
